<template>
  <div class="mc-main-search" :class="{isFilled: search_title.length > 0 && show, isOpen:show}">
    <div class="mc-container">
      <form class="mc-main-search__form" method="get" autocomplete="off"  @submit.prevent="save">
        <div class="mc-main-search__top">
          <div class="mc-main-search__wrapper">
            <button class="mc-main-search__button-search" type="submit" aria-label="Найти">
              <svg class="mc-main-search__button-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-search"></use>
              </svg>
            </button>
            <input @focus="setShow(true)" @input="doSearch" class="mc-main-search__input js-input-search" type="search" :value="search" placeholder="Поиск">
            <button class="mc-main-search__button-delete js-button-delete" type="button">
              <svg class="mc-main-search__button-icon" width="20" height="20" viewBox="0 0 20 20">
                <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
              </svg>
            </button>
          </div>
          <button @click="setShow(false)" class="mc-main-search__button-close js-button-close" type="button">
            Отмена
          </button>
        </div>
        <Gender v-if="show"></Gender>
        <div v-if="search_titleLoaded && search_title.length > 0" class="mc-main-search__result">
          <ul class="mc-main-search__result-list">
            <li v-for="item in search_title" class="mc-main-search__result-item">
              <router-link :to="'/detail/'+item.id+'/'" class="mc-result-card">
                <div class="mc-result-card__image-wrapper">
                  <picture class="mc-result-card__picture">
                    <img class="mc-result-card__image" :src="item.picture" width="94" height="157" alt="">
                  </picture>
                </div>
                <div class="mc-result-card__body">
                                                <span class="mc-result-card__title">
                                                    {{item.name}}
                                                </span>
                  <div class="mc-result-card__price mc-price">
                                                    <span v-if="item.price_old > item.price" class="mc-price__old">
                                                        {{item.price_old}} ₽
                                                    </span>
                    <span class="mc-price__current">
                                                        {{item.price}} ₽
                                                    </span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
          <div class="mc-main-search__result-bottom">
            <router-link class="mc-main-search__result-all" :to="'/category/search/?q='+search">
              Все результаты
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import Gender from "@/views/blocks/Gender.vue";

export default {
  mounted() {

  },
  created() {

  },
  watch: {
    '$route'() {
      this.setShow(false);
    },
    gender(newValue, oldValue) {
      if (oldValue && oldValue != newValue) {
        this.actionSearch();
      }
    }
  },
  unmounted() {
    document.querySelector("body").classList.remove("isMainSearchOpen");
  },
  computed: {
    ...mapGetters([
      'search_title',
      'search_titleLoading',
      'search_titleError',
      'search_titleLoaded',
        'gender'
    ]),
  },
  components: {Gender},
  methods: {
    ...mapActions([
      'fetchSearchTitle'
    ]),
    setShow(show) {
      this.show = show;
      this.$store.commit('UNSET_SEARCH_TITLE');
      if (show)
        document.querySelector("body").classList.add("isMainSearchOpen");
      else {
        document.querySelector("body").classList.remove("isMainSearchOpen");
        this.search = '';
        this.$emit('close');
      }
    },
    doSearch(evt) {
      this.search = evt.target.value;
      this.actionSearch();
    },
    actionSearch: debounce(function() {
      if (this.search.length > 2)
      this.fetchSearchTitle(this.search);
      if (this.search.length == 0)
        this.$store.commit('UNSET_SEARCH_TITLE');
    }, 500),
    save() {
      this.$router.push('/category/search/?q='+this.search);
    }
  },
  data: () => ({
    show: false,
    search: ''
  }),
}
</script>

